import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  addressCell: {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  created: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 'fit-content',
  },
  totalItems: {
    color: theme.palette.red,
  },
}));
